import { createRoute } from "@tanstack/react-router"

import { withGlobalLoader } from "@/lib/context.ts"
import { OrgRoute } from "@/routes/root/RootRoute.tsx"
import { UserProfileModel } from "@/routes/user/UserProfileModel.ts"
import { UserProfileScene } from "@/routes/user/UserProfileScene.tsx"
import { UserSettingsDialogOpener } from "@/routes/user/UserSettingsDialogOpener.tsx"
import { isTabId } from "@/routes/user/UserSettingsTabId.ts"

import type { SettingsTabId } from "@/routes/user/UserSettingsTabId.ts"


export const UserProfileRoute = createRoute({
  path: "user/$username",
  component: () => <UserProfileScene />,

  validateSearch: (search: Record<string, unknown>): { page?: number, successful?: boolean } => {
    return {
      page: Number(search.page) || undefined,
      successful: search.successful === true,
    }
  },

  loaderDeps: ({ search }) => {
    return {
      page: Number(search.page) || 0,
      successful: search.successful === true,
    }
  },

  loader: async ({ context, params, deps }) => {
    const model = new UserProfileModel(context, {
      username: params.username,
      page: deps.page,
      successful: deps.successful,
    })

    await withGlobalLoader(context, model.awaitReady())

    return { model }
  },

  getParentRoute: () => OrgRoute,
})

export const UserSettingsRoute = createRoute({
  path: "settings/$tab",
  component: () => <UserSettingsDialogOpener />,

  beforeLoad: ({ params }) => {
    if (!isTabId(params.tab)) {
      throw new Error(`Invalid settings tab: ${params.tab}`)
    }
  },

  loader: ({ params }) => {
    return {
      tab: params.tab as SettingsTabId,
    }
  },

  getParentRoute: () => OrgRoute
})